@if(loading$ | async) {

<div class="spinner-container">

    <br-loading [visible]="true" size="medium"></br-loading>

</div>

}